module.exports = __webpack_public_path__ + "static/media/UserLaptop.0c8b2b90.png";